import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateAssetFeatureOptionSaga } from "src/store/asset-features-options/saga";
import * as Yup from "yup";
import { SectorDto } from "src/store/system/type";
import { getSectors } from "src/store/system/saga";
import { DeliveryRefundDefinitionPicklistOptionDto } from "src/store/contract-pickup-definition/type";
import { updateDeliveryRefundDefinitionPicklistOption } from "src/store/contract-pickup-definition/saga";

const OptionEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: DeliveryRefundDefinitionPicklistOptionDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Contract.DeliveryOption.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          PicklistOptionName: data.PicklistOptionName,
          DeliveryRefundDefinitionId: data.DeliveryRefundDefinitionId,
          Translates: data.Translates,
        }}
        onSubmit={(values) => {
          dispatch(
            updateDeliveryRefundDefinitionPicklistOption({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          PicklistOptionName: Yup.string().required(
            t("Validation.Required").toString()
          ),
          DeliveryRefundDefinitionId: Yup.string().required(
            t("Validation.Required").toString()
          ),
          Translates: Yup.array(
            Yup.object({
              PicklistOptionName: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "PicklistOptionName",
            label: t("Contract.DeliveryOption.OptionName").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default OptionEditForm;
